/**
 * @desc 库存调整单更新导入sku成本
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/updateImportStockAdjustmentDetailCost`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
